import moment from "moment";
import React, { FunctionComponent, useMemo } from "react";
import { localize } from "src/l10n";
import { SpintrTypes } from "src/typings";
import { Label } from "src/ui";
import { decodeHtmlEntities } from "src/utils";
import "./SearchResultContextRow.scss";

interface IProps {
    item: Spintr.ISearchResult;
}

const usesPublishDate = (type: SpintrTypes.UberType): boolean =>
    type === SpintrTypes.UberType.NewsArticle ||
    type === SpintrTypes.UberType.BlogPost;

const SearchResultContextRow: FunctionComponent<IProps> = (props) => {
    const { item } = props;

    const breadcrumb = useMemo(() => {
        if (!item.path || item.path.length === 0) {
            return "";
        }

        return item.path
            .map((part) => decodeHtmlEntities(part.name, false))
            .filter((name) => !!name)
            .join(" > ");
    }, [item.path]);

    const dateLabel = useMemo(() => {
        const usePublished = usesPublishDate(item.type);
        const value = usePublished
            ? item.created
            : item.lastEdited || item.created;

        if (!value) {
            return "";
        }

        const parsed = moment(value);
        if (!parsed.isValid()) {
            return "";
        }

        const prefix = usePublished
            ? localize("Publicerad")
            : localize("Uppdaterad");

        return `${prefix}: ${parsed.format("L")}`;
    }, [item.type, item.created, item.lastEdited]);

    if (!breadcrumb && !dateLabel) {
        return null;
    }

    return (
        <div className="SearchResultContextRow" aria-hidden="false">
            {!!breadcrumb && (
                <div className="context-breadcrumb">
                    <Label size="body-2" color="visageGray3">
                        {breadcrumb}
                    </Label>
                </div>
            )}
            {!!dateLabel && (
                <div className="context-date">
                    <Label size="body-2" color="visageGray3">
                        {dateLabel}
                    </Label>
                </div>
            )}
        </div>
    );
};

export default SearchResultContextRow;
